<template>
    <section class="user-dashboard-section section-b-space">

        <div class="container-fluid-lg ">
            <div class="dashboard-right-sidebar">
                <div class="dashboard-address">
                <div class="title title-flex">
                    <div>
                        <h2>
                            {{ $t('My Address Book')}}
                        </h2>
                        <span class="title-leaf">
                            <svg class="icon-width bg-gray">
                                <use xlink:href="/theme/assets/svg/leaf.svg#leaf"></use>
                            </svg>
                        </span>
                    </div>

                    <button class="btn theme-bg-color text-white btn-sm fw-bold mt-lg-0 mt-3"
                            data-bs-toggle="modal" data-bs-target="#edit-address"
                            @click="address_edited = null">
                            <i data-feather="plus" class="me-2"></i>
                            {{ $t('Add New Address') }}
                    </button>

                </div>

                <div class="row g-sm-4 g-3">

                    <div class="col-xxl-4 col-xl-6 col-lg-12 col-md-6"
                         v-for="address in items?.data" :key="address.id" >
                        <div class="address-box">
                            <div>
                                <div class="label">
                                    <label>{{ address?.name }}</label>
                                </div>

                                <div class="table-responsive address-table">
                                    <table class="table">
                                        <tbody>
                                        <tr>
                                            <td colspan="2">{{ address?.address }}</td>
                                        </tr>

                                        <tr>
                                            <td>{{ $t('Country') }} :</td>
                                            <td>
                                                <p> {{ address?.country?.name }} </p>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>{{ $t('City') }} :</td>
                                            <td>{{ address?.city?.name }}</td>
                                        </tr>

                                        <tr>
                                            <td>{{ $t('Phone') }} :</td>
                                            <td>{{ address?.phone }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="button-group">

                                <button class="btn btn-sm add-button w-100" data-bs-toggle="modal"
                                        data-bs-target="#edit-address" @click="address_edited = address"><i data-feather="edit"></i>
                                    Edit</button>

                                <button class="btn btn-sm add-button w-100" data-bs-toggle="modal"
                                        data-bs-target="#removeProfile" @click="address_deleted = address"><i data-feather="trash-2"></i>
                                    {{ $t('Delete') }}</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            </div>
        </div>

        <confirmation-modal
            :message="$t('Are you sure you want to delete this address?')"
            @confirm="onDelete" :id="'removeProfile'"/>

<!--        <create-address @add="addItem"></create-address>-->


<!--        <edit-address @update="updateItem" :address="address_edited"></edit-address>-->
        <form-address
            @on_update="updateItem"
            @on_add="addItem"
            :address="address_edited"></form-address>

    </section>
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();
import { Bootstrap5Pagination } from 'laravel-vue-pagination'

import FormAddress from "./form.vue";
//
// import EditAddress from "./edit.vue";
// import CreateAddress from "./create.vue";
import ConfirmationModal from "../../components/handling/ConfirmationModal.vue";

export default {
    components:{
        Bootstrap5Pagination,
        // CreateAddress,
        // EditAddress,
        FormAddress,
        ConfirmationModal
    },
    data() {
        return {
            address_edited: {},
            address_deleted: {},
            items: {},
            q: this.$route.query,
            form_options: {},
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        addItem(newItemData) {
            console.log('addItem');
            console.log(newItemData);
            this.items?.data?.unshift(newItemData);
        },
        updateItem(newItemData) {
            console.log('updateItem');
            console.log(newItemData);
            const itemIndex = this.items?.data?.findIndex(item => item.id === newItemData.id);
            console.log(itemIndex);
            if (itemIndex !== -1) {
                this.items.data[itemIndex] = { ...this.items?.data[itemIndex], ...newItemData };
            }
        },
        async onDelete() {
            await this._delete(this.address_deleted);
            this.address_deleted = {};
        },
        getResults ( ) {

            const id = toast.info(this.$t('Getting content ...'),{ icon: 'fa-solid fa-download' });
            axios.get('addresses', ).then(response => {
                toast.dismiss(id);
                this.items = response.data;
            }, response => {
                toast.dismiss(id);
            });

        },
        async _delete(item) {
            const toastId = toast.info('deleting ...', {icon: 'fa-solid fa-trash-arrow-up'});
            await axios.delete(`addresses/${item.id}`)
                .then(response => {
                    toast.dismiss(toastId);
                    // toast.success(response.data.message, {icon: 'fa-solid fa-trash-arrow-up'});
                    let i = this.items.data.map(v => v.id).indexOf(this.address_deleted.id);
                            this.items.data.splice(i, 1)

                });
        }
    }
}
</script>
